import axios from 'axios';

export const equipmentReportPdfApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipment-report-pdf`,
    headers: {
        'Content-Type': 'application/json'
    }
})